class CatalogMegaMenu extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.onScroll();
    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.classList.toggle('mini', scrollTop > 200);
  }
}

customElements.define('catalog-mega-menu', CatalogMegaMenu);
